"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function truncateAtWordBoundary(text, maxLength) {
  if (!Number.isFinite(maxLength)) {
    return text;
  }
  if (!text || text.length <= maxLength) {
    return text;
  }
  var truncated = text.slice(0, maxLength);
  var lastSpaceIndex = truncated.lastIndexOf(' ');
  var result = '';
  if (lastSpaceIndex > 0) {
    result = truncated.slice(0, lastSpaceIndex).trim();
  } else {
    result = truncated.trim();
  }
  result = result.replace(/[.,;:!?\-—]+$/, '');
  return result + '...';
}
var _default = exports["default"] = truncateAtWordBoundary;